<div class="young-adults-header" *ngIf="youngAdultsSchoolInfo">
  <lx-price-lists-portal-school-header
    [company]="youngAdultsSchoolInfo.company"
    [school]="youngAdultsSchoolInfo.school?.name"
    [country]="youngAdultsSchoolInfo.country"
    [subtitle]="youngAdultsSchoolInfo.minAge | lxJuniorCampAges : youngAdultsSchoolInfo.maxAge"
    [disclaimer]="includedInPackageNote"
    [applicationForms]="applicationForms"
    [schoolDescription]="youngAdultsSchoolInfo.languages | lxJuniorCampsSchoolDescription"
  ></lx-price-lists-portal-school-header>
</div>
